import React, { useCallback, useContext, useEffect, useState } from "react";
import { getAllHours, getNext10Days } from "../../utils/utils";
import moment from "moment";
import Button from "../../VibehutUI/Button";
import RequestEventCard from "./RequestEventCard";
import { getAllRequestEvents } from "../../actions/requestEventActions";
import { StoreContext } from "../../Context/StoreContext";
import Loader from "../../VibehutUI/Loader";
import { getUserUpcomingRoomEvents } from "../../services/eventService";

function SelfOrganizedEvents({ room, roomOwner }) {
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth: { user },
    requestEvent: { requestEvents, isFetching },
  } = state;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [next10Days, setNext10Days] = useState([]);
  const [eventFilter, setEventFilter] = useState("all");
  const [requestEventsPlaceholders, setRequestEventsPlaceholders] = useState(
    [],
  );
  const [rsvpdEvents, setRsvpdEvents] = useState([]);
  const next10DaysFun = useCallback(() => {
    const _next10Days = getNext10Days();
    const currentDate = _next10Days[0];
    let reqPlaceholder = getAllHours(currentDate);

    if (reqPlaceholder.length === 0) {
      const nextDate = _next10Days[1];
      reqPlaceholder = getAllHours(nextDate);
    }
    setRequestEventsPlaceholders(reqPlaceholder);
    setNext10Days(_next10Days);
    setSelectedDate(_next10Days[0]);
  }, []);

  useEffect(() => {
    next10DaysFun();
  }, [next10DaysFun, rsvpdEvents]);

  const getUserRsvpdEvents = useCallback(
    async (room) => {
      try {
        const response = await getUserUpcomingRoomEvents(user?.token, room);
        setRsvpdEvents(response.data);
      } catch (error) {}
    },
    [user?.token],
  );

  useEffect(() => {
    if (room) {
      getAllRequestEvents(room._id, dispatch);
      getUserRsvpdEvents(room._id);
    }
  }, [dispatch, getUserRsvpdEvents, room]);

  const checkDateIsSameOrNot = (date) => {
    const selectedDay = moment(selectedDate).format("D");
    const dateDate = moment(date).format("D");
    if (selectedDay === dateDate) {
      return true;
    }
    return false;
  };

  const onDateChange = (date) => {
    setSelectedDate(date);
    const reqPlaceholder = getAllHours(date);
    setRequestEventsPlaceholders(reqPlaceholder);
  };
  const handleTabChange = (tab) => {
    let next10Days = getNext10Days();
    if (tab === "requested") {
      next10Days = next10Days.filter((date) => {
        const dateDay = moment(date).date();
        return requestEvents.some((event) => {
          const eventStartDate = moment(event.startDate);
          return dateDay === eventStartDate.date();
        });
      });
    }
    setSelectedDate(next10Days[0]);
    const currentDate = next10Days[0];
    const reqPlaceholder = getAllHours(currentDate);
    setNext10Days(next10Days);
    setRequestEventsPlaceholders(reqPlaceholder);

    setEventFilter(tab);
  };

  return (
    <div className="md:pr-10 pt-1 flex flex-col max-w-md">
      <p className="text-base font-bold pb-2 text-black dark:text-frescoWhite">
        Booking - Share Your Availability
      </p>
      <p className="text-sm font-normal  text-darkGray whitespace-pre-wrap">
        Select the time slots you’re available to talk. When{" "}
        <span className="font-bold">
          {" "}
          {room?.selfOrganizeCount || 2} people
        </span>{" "}
        pick the same time an event will be automatically organized and
        announced.
      </p>
      <div className="flex justify-end gap-1 pt-4">
        <Button
          onClick={() => handleTabChange("all")}
          variant={eventFilter === "all" ? "primary" : "vibhut-primary-outline"}
        >
          All
        </Button>
        <Button
          onClick={() => handleTabChange("requested")}
          variant={
            eventFilter === "requested" ? "primary" : "vibhut-primary-outline"
          }
        >
          Interested ({requestEvents.length}🔥)
        </Button>
      </div>
      {eventFilter === "requested" && requestEvents?.length === 0 ? (
        <></>
      ) : (
        <div className="flex gap-[18px] overflow-hidden overflow-x-auto custom-scrollbar pt-4">
          {next10Days.map((date) => {
            return (
              <div key={date} className="flex flex-col items-center">
                <p className="font-bold text-matteGray text-sm dark:text-darkGray">
                  {checkDateIsSameOrNot(date)
                    ? moment(date).format("ddd")
                    : moment(date).format("ddd").substring(0, 1)}
                </p>
                <Button
                  variant={
                    checkDateIsSameOrNot(date)
                      ? "primary"
                      : "vibhut-primary-outline"
                  }
                  customClasses={`hover:text-white hover:bg-primary ${
                    checkDateIsSameOrNot(date) ? "border border-primary" : ""
                  } `}
                  onClick={() => onDateChange(date)}
                >
                  {checkDateIsSameOrNot(date) ? (
                    <p className="w-12">{moment(date).format("MMM D")}</p>
                  ) : (
                    <p className="">{moment(date).format("D")}</p>
                  )}
                </Button>
              </div>
            );
          })}
        </div>
      )}{" "}
      {!isFetching ? (
        <div className="flex flex-col gap-3.5 h-80 overflow-hidden custom-scrollbar overflow-y-auto pt-3">
          {requestEventsPlaceholders.map((date, index) => (
            <RequestEventCard
              key={date + index}
              date={date}
              room={room}
              roomOwner={roomOwner}
              placeHolderIndex={index}
              eventFilter={eventFilter}
            />
          ))}
          {eventFilter === "requested" && requestEvents?.length === 0 && (
            <p className="text-sm font-normal text-darkGray">
              There are no current requested times. Make a request to let others
              know you're looking to talk.
            </p>
          )}
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default SelfOrganizedEvents;
